export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_TC_3M_79_3M_15_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_3m_79_3m_15_99_usd',
			EUR: 'simple_premium_3m_79_3m_15_99_eur',
			GBP: 'simple_premium_3m_79_3m_15_99_gbp',
			AUD: 'simple_premium_3m_129_3m_23_99_aud',
			CAD: 'simple_premium_3m_129_3m_23_99_cad',
			DKK: 'simple_premium_3m_679_3m_127_2_dkk',
			SEK: 'simple_premium_3m_1039_3m_207_2_sek',
			NOK: 'simple_premium_3m_1039_3m_207_2_nok',
			BRL: 'simple_premium_3m_319_3m_63_2_brl',
			MXN: 'simple_premium_3m_1299_3m_255_2_mxn',
			TRY: 'simple_premium_3m_2569_3m_519_2_try',
			ARS: 'simple_premium_3m_105389_3m_21335_2_ars',
			COP: 'simple_premium_3m_315999_3m_63967_2_cop',
			CLP: 'simple_premium_3m_79000_3m_15992_clp',
		},
		primer: 'prd_zMxVF811QQ0P',
	},
}
